import React from 'react'
import HomePartnersBuilder from 'components/Home/HomePartnersBuilder'

export default function PartnersLogos({data}) {
    const {partnersLogosTitle, partnersLogosSubtitle, partnersLogosLogos} = data
    return (
        <div className='partners-wrap slick-image-arrow'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center mb-4'>
                        <h2 className='heading-level-2 blue-color'>{partnersLogosTitle}</h2>
                        <p>
                            <strong>{partnersLogosSubtitle}</strong>
                        </p>
                    </div>

                    <div className='col-md-12'>
                        <HomePartnersBuilder partnersHome={partnersLogosLogos} />
                    </div>
                </div>
            </div>
        </div>
    )
}
